<template>
    <van-tabs
        v-model="active"
        active-color="#07c160"
        inactive-color="#000" @click="click">
        <van-tab v-for="itm in data" :title="itm.name" :key="itm.id" :name="itm.id" />
    </van-tabs>
</template>

<script>
import { Tabs, Tab } from 'vant';
import { ClsApi } from '@/api/market'
export default {
    name: 'Cls1Tab',
    props: ['parent'],
    components: {
        [Tabs.name]: Tabs,
        [Tab.name]: Tab
    },
    data() {
        return {
            active: 0,
            data: []
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.axios.get(ClsApi, {params: {issupply: true, cls: this.parent }}).then((ret) => {
                if (ret.length>0) {
                    ret[0].id = 0
                    ret[0].name = '所有'
                }
                that.data = ret
            })
        },
        click(id, title) {
            this.$emit('pick', {id: id, name: title})
        }
    }
}
</script>

<style lang="less" scope>
#carno {
    .areashort {
        .sel {
            font-weight: bold;
            background: #f7f8fa;
            color: red;
        }
        .normal {
            font-weight: normal;
        }
    }
    .curareashort {
        font-weight: bold;
        background-color: #f7f8fa;
        width: 60px;
        font-size: 2em;
        color: red;
    }
}
</style>